import { Button } from "react-bootstrap";
import { MdDeleteForever } from "react-icons/md";
import { useState } from 'react';

function Policial({ policial, index, boletim, setBoletim }) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(policial);
  const [error, setError] = useState('');
  const remover = () => {
    setBoletim(current => ({ ...current, efetivo: current.efetivo.filter((_, i) => i !== index) }));
  };
  if (editing) return <form className="bo-section" onSubmit={event => {
    event.preventDefault();
    if (boletim.efetivo.some((item, i) => i !== index && String(item.id).trim() === String(draft.id).trim())) {
      setError('Esta matrícula já está no efetivo.');
      return;
    }
    setBoletim(current => {
      return { ...current, efetivo: current.efetivo.map((item, i) => i === index ? { ...item, ...draft } : item) };
    });
    setEditing(false);
  }}>
    {Object.entries({ id: 'Matrícula', nome: 'Nome', graduacao: 'Posto / Graduação', numeroBarra: 'Número / Barra', vtr: 'VTR' }).map(([field, label]) =>
      <label className="bo-field" key={field}>{label}<input required={['id', 'nome', 'vtr'].includes(field)} value={draft[field] || ''} onChange={event => setDraft({ ...draft, [field]: event.target.value })} /></label>)}
    {error && <p role="alert">{error}</p>}
    <Button type="submit">Salvar integrante</Button>{' '}
    <Button type="button" variant="secondary" onClick={() => setEditing(false)}>Cancelar</Button>
  </form>;

  return (
    <div className="material-item">
      <div>
        <div className="material-title">{policial.nome}</div>
        <div className="material-subtitle">
          Matrícula: {policial.id} · VTR: {policial.vtr}
        </div>
      </div>

      <Button size="sm" variant="outline-primary" onClick={() => { setDraft(policial); setError(''); setEditing(true); }}>Editar</Button>
      <Button size="sm" aria-label={`Excluir ${policial.nome}`} variant="outline-danger" onClick={remover}>
        <MdDeleteForever />
      </Button>
    </div>
  );
}

export default Policial;
